export default {"src":"/_next/static/media/paypal.fde0d118.svg","height":33,"width":124};